/// <reference path="../../../../typings/index.d.ts" />
angular.module('app').factory('ReportServiceApi', ($http, ApiErrorService) => {
    return {
        getTesterCertReport: getTesterCertReport,
        getTCRSummaryReport: getTCRSummaryReport,
        getTestSuiteExpiryReport: getTestSuiteExpiryReport,
        getVerdictSummaryReport: getVerdictSummaryReport,
        getVerdictReportRows: getVerdictReportRows,
        getTesterIdReport: getTesterIdReport,
        getUserAccessReport: getUserAccessReport,
        getSimulatorLastMessages: getSimulatorLastMessages,
        getSimulatorMessageTypes: getSimulatorMessageTypes,
        getArchiveAuditReport: getArchiveAuditReport,
        getAuditLookups: getAuditLookups,
        getActiveTesters: getActiveTesters,
        getManagedTesterTeamUsers: getManagedTesterTeamUsers,
        getAllTestersWithTestProjects: getAllTestersWithTestProjects,
        testerSimSuites: testerSimSuites,
        getManagementReport: getManagementReport,
        getTesterUsageReport: getTesterUsageReport,
        refreshTesterUsageTotals: refreshTesterUsageTotals,
        getReports: getReports,
        getReportByName: getReportByName,
        saveReports: saveReports,
        saveReport: saveReport,
        deactivateReport: deactivateReport,
        getAllSelectedUserTestCases: getAllSelectedUserTestCases,
        getTeamSelectedUserTestCases: getTeamSelectedUserTestCases,
        getManagedTesterTestStatusReportDeprecated: getManagedTesterTestStatusReportDeprecated,
        getTesterTestStatusReport: getTesterTestStatusReport,
        getManagedTesterTestStatusReport: getManagedTesterTestStatusReport,
        getManagedTesterCertificationReport: getManagedTesterCertificationReport,
        getManagedTesterReportProjectData: getManagedTesterReportProjectData,
        getManagedTesterIterationLookups: getManagedTesterIterationLookups,
        generateReport: generateReport,
        getReportReady: getReportReady,
        getReportParameters: getReportParameters
    };
    function getTesterCertReport(req) {
        return $http.post(`api/Report/GetTesterCertReport`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTCRSummaryReport(req) {
        return $http.post(`api/Report/GetTCRSummaryReport`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTestSuiteExpiryReport() {
        return $http.get(`api/Report/GetTestSuiteExpiryReport`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getVerdictSummaryReport(req) {
        return $http.post(`api/Report/GetVerdictSummaryReport`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getVerdictReportRows(req) {
        return $http.post(`api/Report/GetVerdictReportRows`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTesterIdReport(req) {
        return $http.post(`api/Report/GetTesterIdReport`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getUserAccessReport(req) {
        return $http.post(`api/Report/GetUserAccessReport`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorLastMessages(req) {
        return $http.post(`api/Report/GetSimulatorLastMessages`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getSimulatorMessageTypes() {
        return $http.get(`api/Report/GetSimulatorMessageTypes`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getArchiveAuditReport(req) {
        return $http.post(`api/Report/GetArchiveAuditReport`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAuditLookups() {
        return $http.get(`api/Report/GetAuditLookups`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getActiveTesters() {
        return $http.get(`api/Report/GetActiveTesters`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getManagedTesterTeamUsers(teamId) {
        return $http.get(`api/Report/GetManagedTesterTeamUsers?teamId=${teamId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllTestersWithTestProjects() {
        return $http.get(`api/Report/GetAllTestersWithTestProjects`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function testerSimSuites(testerId) {
        return $http.get(`api/Report/TesterSimSuites?testerId=${testerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getManagementReport(req) {
        return $http.post(`api/Report/GetManagementReport`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTesterUsageReport(timeframe, timezoneOffset) {
        return $http.get(`api/Report/TesterUsage?timeframe=${timeframe}&timezoneOffset=${timezoneOffset}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function refreshTesterUsageTotals() {
        return $http.get(`api/Report/TesterUsage/Refresh`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getReports() {
        return $http.get(`api/Report/GetReports`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getReportByName(reportName) {
        return $http.get(`api/Report/GetReportByName?reportName=${encodeURIComponent(reportName)}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveReports(reports) {
        return $http.post(`api/Report/SaveReports`, reports)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function saveReport(report) {
        return $http.post(`api/Report/SaveReport`, report)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function deactivateReport(reportId) {
        return $http.post(`api/Report/DeactivateReport?reportId=${reportId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getAllSelectedUserTestCases() {
        return $http.get(`api/Report/GetAllSelectedUserTestCases`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTeamSelectedUserTestCases(TeamId) {
        return $http.get(`api/Report/GetTeamSelectedUserTestCases?TeamId=${TeamId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getManagedTesterTestStatusReportDeprecated(testerId, projectIterationId) {
        return $http.get(`api/Report/GetManagedTesterTestStatusReportDeprecated?testerId=${testerId}&projectIterationId=${projectIterationId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getTesterTestStatusReport(testerId, simId) {
        return $http.get(`api/Report/GetTesterTestStatusReport?testerId=${testerId}&simId=${simId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getManagedTesterTestStatusReport(testerId, projectIterationId) {
        return $http.get(`api/Report/GetManagedTesterTestStatusReport?testerId=${testerId}&projectIterationId=${projectIterationId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getManagedTesterCertificationReport(testerId, projectIterationId) {
        return $http.get(`api/Report/GetManagedTesterCertificationReport?testerId=${testerId}&projectIterationId=${projectIterationId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getManagedTesterReportProjectData(testerId, projectIterationId) {
        return $http.get(`api/Report/GetManagedTesterReportProjectData?testerId=${testerId}&projectIterationId=${projectIterationId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getManagedTesterIterationLookups(testerId) {
        return $http.get(`api/Report/GetManagedTesterIterationLookups?testerId=${testerId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function generateReport(req) {
        return $http.post(`api/Report/GenerateReport`, req)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getReportReady(simId, userId) {
        return $http.get(`api/Report/GetReportReady?simId=${simId}&userId=${userId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
    function getReportParameters(simId, userId, reportId) {
        return $http.get(`api/Report/GetReportParameters?simId=${simId}&userId=${userId}&reportId=${reportId}`, null)
            .then(function (response) {
            return response;
        }, function (response) {
            ApiErrorService.error(response);
        });
    }
});
